import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { easeOut, prefersReducedMotion } from '@atlaskit/motion';
import { N30A, N60A } from '@atlaskit/theme/colors';
export var skipLinkStyles = _objectSpread(_objectSpread({
  zIndex: -1,
  left: -999999,
  position: 'fixed',
  opacity: 0,
  background: 'white',
  border: 'none',
  padding: '0.8rem 1rem',
  boxShadow: "0 0 0 1px ".concat(N30A, ", 0 2px 10px ").concat(N30A, ", 0 0 20px -4px ").concat(N60A),
  borderRadius: '3px',
  margin: 10
}, prefersReducedMotion()), {}, {
  transform: 'translateY(-50%)',
  transition: "transform 0.3s ".concat(easeOut),
  ':focus-within': {
    transform: 'translateY(0%)',
    opacity: 1,
    left: 0,

    /* Max z-index is 2147483647. Skip links always be on top,
              but giving a few digits extra space just in case there's
              a future need. */
    zIndex: 2147483640
  },
  '& > span': {
    fontWeight: 'bold'
  },
  '> ol': {
    listStyleType: 'none',
    listStylePosition: 'outside',
    paddingLeft: 0,
    marginTop: '4px',
    '> li': {
      marginTop: 0
    }
  }
});